module.exports = __webpack_public_path__ + "img/party.c361c07c.webp";